var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-panel', {
    class: _vm.theme.appBar
  }, [_c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding.left",
      value: (2),
      expression: "2",
      modifiers: {
        "left": true
      }
    }, {
      name: "padding",
      rawName: "v-padding.right",
      value: (2),
      expression: "2",
      modifiers: {
        "right": true
      }
    }]
  }, [_c('v-row', {
    attrs: {
      "align-items": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "xs": "6"
    }
  }, [_c('balance')], 1), _vm._v(" "), _c('v-col', {
    directives: [{
      name: "text-align",
      rawName: "v-text-align.right",
      modifiers: {
        "right": true
      }
    }]
  }, [_c('company-menu')], 1)], 1)], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21c053d8","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/AppBar/AppBar.vue
// module id = 1177
// module chunks = 0